import React from "react";
import PopoverField from "./PopoverField";
import "./styles/PopoverField.css";

/**
 * NumberRangeFilter - Min/max number inputs in a filter popover.
 * @param {Object} props
 * @param {string} props.label - Filter label
 * @param {string} props.fromValue - Min value
 * @param {string} props.toValue - Max value
 * @param {Function} props.onFromChange - Change handler for the min value
 * @param {Function} props.onToChange - Change handler for the max value
 * @param {string} props.align - 'left' (default) or 'right' panel alignment
 */
const NumberRangeFilter = ({
  label,
  fromValue,
  toValue,
  onFromChange,
  onToChange,
  align,
}) => {
  return (
    <PopoverField
      label={label}
      align={align}
      active={Boolean(fromValue || toValue)}
    >
      <div className="dsRangeRow">
        <input
          type="number"
          className="dsRangeInput"
          placeholder="From"
          aria-label={`${label} minimum`}
          value={fromValue}
          onChange={onFromChange}
        />
        <span className="dsRangeSeparator">to</span>
        <input
          type="number"
          className="dsRangeInput"
          placeholder="To"
          aria-label={`${label} maximum`}
          value={toValue}
          onChange={onToChange}
        />
      </div>
    </PopoverField>
  );
};

export default NumberRangeFilter;
